import { Text, View } from "./Base";

import InfoIcon from "@mui/icons-material/Info";
import { makeStyles } from "@mui/styles";
import { palette } from "../theme/palette";

const useStyles = makeStyles({
  messageContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "40px",
  },
  message: {
    marginTop: "20px",
    fontSize: "14px",
    color: palette.typography.white.high,
  },
  icon: {
    color: palette.typography.white.high,
  },
});

export const InfoMessage = ({ message }) => {
  const styles = useStyles();

  return (
    <View className={styles.messageContainer}>
      <InfoIcon className={styles.icon} />
      <Text className={styles.message}>{message}</Text>
    </View>
  );
};
